import { render, staticRenderFns } from "./MarketNavigationDrawer.vue?vue&type=template&id=2dcc534a&scoped=true"
import script from "./MarketNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./MarketNavigationDrawer.vue?vue&type=script&lang=js"
import style0 from "./MarketNavigationDrawer.vue?vue&type=style&index=0&id=2dcc534a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc534a",
  null
  
)

export default component.exports